export default "__VITE_ASSET__DoISpztY__"